import { http } from '@/shared/api/axios';
import type {
  EmployeeCredential,
  CreateEmployeeCredentialRequest,
  UpdateEmployeeCredentialRequest,
  UpdateEmployeeCredentialResponse,
} from '../model/types';

const appendIfSet = (form: FormData, key: string, value: string | null | undefined) => {
  if (value !== null && value !== undefined && value !== '') {
    form.append(key, value);
  }
};

const buildCreateForm = (req: CreateEmployeeCredentialRequest): FormData => {
  const form = new FormData();
  form.append('CredentialName', req.credentialName);
  appendIfSet(form, 'CredentialNumber', req.credentialNumber);
  appendIfSet(form, 'IssuingAuthority', req.issuingAuthority);
  appendIfSet(form, 'IssuedOn', req.issuedOn);
  appendIfSet(form, 'ExpiresOn', req.expiresOn);
  appendIfSet(form, 'Notes', req.notes);
  if (req.document) {
    form.append('Document', req.document);
  }
  return form;
};

const buildUpdateForm = (req: UpdateEmployeeCredentialRequest): FormData => {
  const form = buildCreateForm(req);
  if (req.clearDocument) {
    form.append('ClearDocument', 'true');
  }
  return form;
};

export const credentialApi = {
  listMine: async (): Promise<EmployeeCredential[]> => {
    const { data } = await http.get<EmployeeCredential[]>('/v1/me/credentials');
    return data;
  },
  getMine: async (id: number): Promise<EmployeeCredential> => {
    const { data } = await http.get<EmployeeCredential>(`/v1/me/credentials/${id}`);
    return data;
  },
  create: async (req: CreateEmployeeCredentialRequest): Promise<EmployeeCredential> => {
    const { data } = await http.post<EmployeeCredential>('/v1/me/credentials', buildCreateForm(req), {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },
  update: async (
    id: number,
    req: UpdateEmployeeCredentialRequest
  ): Promise<UpdateEmployeeCredentialResponse> => {
    const { data } = await http.put<UpdateEmployeeCredentialResponse>(
      `/v1/me/credentials/${id}`,
      buildUpdateForm(req),
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return data;
  },
  delete: async (id: number): Promise<void> => {
    await http.delete(`/v1/me/credentials/${id}`);
  },
  listForEmployee: async (employeeId: number): Promise<EmployeeCredential[]> => {
    const { data } = await http.get<EmployeeCredential[]>(
      `/v1/employees/${employeeId}/credentials`
    );
    return data;
  },
};
